import useScript from "hooks/scripts/useScript";

export default function useGoogleIdentityScript(): string {
  return useScript("https://accounts.google.com/gsi/client", {
    defer: true,
    // See https://developers.google.com/identity/gsi/web/guides/get-google-api-clientid for why
    referrerpolicy: "no-referrer-when-downgrade",
  });
}
